import { WSPillProps } from "@wingspanhq/fe-component-library";
import { PayrollRunStatus } from "@wingspanhq/wingspan-api-sdk";

/**
 * Pill for a v3 `PayrollRunStatus`. Several statuses share a presentation:
 * `Finalized` and `Processing` both read as "Processing" (funds in flight).
 *
 * `PartiallyPaid` renders as "Pending" — it has no dedicated treatment in the
 * design, and this preserves what the previous status mapping fell through to.
 *
 * `Cancelled` is a deliberate operator action, not a failure, so it gets the
 * codebase's neutral "Cancelled" treatment rather than the red "Failed" pill.
 */
const PAYROLL_RUN_STATUS_PILL: Record<PayrollRunStatus, WSPillProps> = {
  [PayrollRunStatus.DRAFT]: {
    theme: "blue",
    icon: "info-circle",
    text: "Opened"
  },
  [PayrollRunStatus.PENDING_APPROVALS]: {
    theme: "warning",
    icon: true,
    text: "Pending"
  },
  [PayrollRunStatus.FINALIZED]: {
    theme: "warning",
    icon: true,
    text: "Processing"
  },
  [PayrollRunStatus.PROCESSING]: {
    theme: "warning",
    icon: true,
    text: "Processing"
  },
  [PayrollRunStatus.PAID]: {
    theme: "success",
    icon: true,
    text: "Completed"
  },
  [PayrollRunStatus.PARTIALLY_PAID]: {
    theme: "warning",
    icon: true,
    text: "Pending"
  },
  [PayrollRunStatus.CANCELLED]: {
    theme: "neutral",
    text: "Cancelled"
  },
  [PayrollRunStatus.FAILED]: { theme: "error", icon: true, text: "Failed" }
};

/** A run with no status yet reads as pending, matching the API default. */
export const selectorPayrollRunStatusPill = (
  status?: PayrollRunStatus
): WSPillProps =>
  PAYROLL_RUN_STATUS_PILL[status ?? PayrollRunStatus.PENDING_APPROVALS];
